import { useEffect, useState } from "react";
import CookiePreferencesModal from "./CookiePreferencesModal";
import { ClientPortalCookiePreferencesModel } from "services/api/cplauthapi/CPLAuthAPI";
import useCookies from "hooks/useCookies";

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { preferences, setPreferences } = useCookies();

  const submitCookiePreferences = (values: ClientPortalCookiePreferencesModel) => {
    setPreferences(values);
    setShowBanner(false);
  };

  useEffect(() => {
    setShowBanner(preferences == null);
  }, [preferences]);

  if (!showBanner) {
    return <></>;
  }

  return (
    <div>
      <CookiePreferencesModal showModal={showModal} setShowModal={setShowModal} />
      <div className="fixed-bottom mx-5 mb-1">
        <div className="d-flex flex-column flex-md-row border border-primary mx-auto p-4 gap-1 row-gap-4 justify-content-between align-items-center bg-white">
          <div className="w-75">
            <strong>We value your privacy</strong>
            <p>
              We use some essential cookies to make this site work. We'd also like to set analytics cookies to
              understand how you use this site, and functional cookies to improve your user experience. To personalise
              your choice and learn more, click here to adjust your preferences:{" "}
              <a
                type="button"
                className="cpl-text-primary"
                onClick={() => setShowModal(true)}
                data-test-id="cookie-banner__cookie-policy-button"
              >
                Cookie Policy
              </a>
            </p>
          </div>
          <div className="d-flex justify-content-center gap-1 gap-md-3">
            <button
              className="cpl-btn cpl-btn-primary"
              data-test-id="cookie-banner__accept-all-button"
              onClick={() =>
                submitCookiePreferences(
                  new ClientPortalCookiePreferencesModel({ functionalEnabled: true, analyticsEnabled: true })
                )
              }
            >
              Accept All
            </button>
            <button
              className="cpl-btn cpl-btn-primary"
              data-test-id="cookie-banner__accept-essential-button"
              onClick={() =>
                submitCookiePreferences(
                  new ClientPortalCookiePreferencesModel({ functionalEnabled: false, analyticsEnabled: false })
                )
              }
            >
              Accept Essential
            </button>
            <button
              className="cpl-btn cpl-btn-primary"
              onClick={() => setShowModal(true)}
              data-test-id="cookie-banner__customise-button"
            >
              Customise
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
